import { Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { defaultFormValues } from "app/@core/utils/defaultFormValues";

@Component({
    selector: 'ngx-assessment-form-settings',
    templateUrl: './assessmentFormSettings.component.html',
    styleUrls: ['./assessmentFormSettings.component.scss'],
})
export class AssessmentFormSettingsComponent {
    field: FormlyFieldConfig;
    formStructureFields: FormlyFieldConfig[] = [ ];
    constructor(private dialogRef: NbDialogRef<AssessmentFormSettingsComponent>) {}
    removeOption(index: number): void {
        (this.field.templateOptions.options as []).splice(index,1)
    }
    addOption(): void {
        (this.field.templateOptions.options as any[]).push({
            label: '',
            value: ''
        })
    }

    public get validKeyString(): string {
      if(!this.field.key || this.field.key?.toString().trim() === '') {
        return 'Key is required'
      }
      let foundedKey = this.formStructureFields.find((field) => field.key === this.field.key);
      let foundKeyIsInDefault = defaultFormValues.find((field) => field.key === this.field.key);
      if(foundedKey || foundKeyIsInDefault) {
        return 'Key already exists';
      }
      return null;
    }

    onSubmit() {
      if(this.field.templateOptions.options) {
      this.field.templateOptions.options = (this.field.templateOptions.options as any[])?.map(x => ({
        ...x,
        value: x.label
      }));
    }
        this.dialogRef.close(this.field);
    }

    close() {
        this.dialogRef.close();
    }
}
